import { ModifyLoanContext } from '@chargeafter/payment-types';

import { logger } from '../../logger';
import { paymentsPresent } from '../present/payments/paymentsPresent';
import { printInitError } from '../printInitError/printInitError';
import { store } from '../store';

const filename = 'modifyLoan';

export const modifyLoan = async (
  sessionToken: string,
  context: ModifyLoanContext
) => {
  if (!store.isInitialized) return printInitError('modifyLoan', filename);

  logger.linkId = store.config?.linkId;

  logger.log(`about to present ModifyLoan`, {
    function: 'modifyLoan',
    filename,
    context,
  });

  return paymentsPresent('modifyLoan', {
    ...context,
    sessionToken,
  });
};
